export default {
  app: {
    featured: 'Featured Cocktails', // Intent: Discoverability
    random: 'Surprise Me!', // Intent: User Engagement (fun, interactive)
    explore: 'Discover Drinks', // Intent: Discoverability, SEO-friendly
    keywords: 'Search by Cocktail Flavor', // Intent: SEO with action
    search: 'Search Recipes', // Intent: Discoverability
  },
  explore: {
    filters: 'Refine Your Search', // Intent: Conversion, UX-friendly
    resetFilters: 'Clear All Filters', // Intent: Conversion
    addKeyword: 'Add a Flavor Keyword', // Intent: User Engagement
  },
  recipe: {
    contributedBy: 'Shared by Bartend Long Island', // Intent: Branding, Conversion
    ingredients: 'What You’ll Need', // Intent: Engagement, UX-friendly
    directions: 'How to Make It', // Intent: SEO-friendly
    fullRecipe: 'Learn Bartending and Explore Best Cocktail Recipes at', // Intent: Discoverability, SEO
    similarDrinks: 'You Might Also Like', // Intent: Engagement, Upsells
  },
  featuredRecipes: {
    loadMore: 'Show More Cocktail Ideas', // Intent: SEO-friendly, Discoverability
  },
  recipeFind: {
    filterBy: 'Narrow Your Search', // Intent: Conversion
    name: 'Cocktail Name', // Intent: UX-friendly
    ingredients: 'Search by Ingredients', // Intent: SEO-friendly
    keywords: 'Search by Flavor', // Intent: SEO-friendly
    searchForIngredients: 'Search multiple ingredients separated by spaces', // Intent: UX
    searchForKeywords: 'Search multiple flavors separated by spaces', // Intent: UX
  },
  recipeList: {
    viewRecipe: 'View Full Recipe', // Intent: Conversion
  },
  recipeToolbar: {
    print: 'Print Recipe', // Intent: User Convenience
    share: 'Share Your Favorite', // Intent: Engagement, Branding
    shareOnFacebook: 'Post on Facebook', // Intent: Social Media SEO
    shareOnTwitter: 'Tweet This Recipe', // Intent: Social Media SEO
    copyURL: 'Copy Recipe Link', // Intent: Sharing
    hideImage: 'Hide Drink Image', // Intent: Customization
    setFavorite: 'Add to Favorites', // Intent: Conversion, Engagement
    unsetFavorite: 'Remove from Favorites', // Intent: Conversion, Engagement
    urlCopied: 'Recipe Link Copied!', // Intent: UX
    urlCopiedInClipboard: 'The link is now in your clipboard!', // Intent: UX
  },
  keywordList: {
    enterYourKeyword: 'Enter a Flavor or Ingredient', // Intent: UX, SEO
  },
  favorites: {
    removeAllFavorites: 'Clear Your Favorite Drinks', // Intent: Engagement
    noFavoriteDrinks: 'You don’t have any drinks saved yet.', // Intent: Engagement
    removeFavoritesPrompt: 'Are you sure you want to clear all favorites?', // Intent: UX
    delete: 'Delete Favorites', // Intent: UX
    cancel: 'Keep Favorites', // Intent: UX
  },
  search: {
    findYourDrink: 'What Will You Mix Next?', // Intent: Discoverability, Engagement
  },
  pageNotFound: {
    pageNotFound: 'Oops! This Page Doesn’t Exist.', // Intent: UX
    backToHome: 'Back to the Cocktail Cabinet', // Intent: Branding
  },
};
